export default __webpack_public_path__ + "static/media/7AudiA4.c48b600f.jpg";